<template>

    <v-layout row wrap>
        <v-flex xs12 sm6 offset-sm3>
            <v-expansion-panel popout v-model="panel">
                <v-expansion-panel-content

                >
                    <template v-slot:header>
                        <div>お受取方法: {{userSelect.service.langName}}</div>
                    </template>
                    <p class="pa-2 headline">どのように商品をお受取になりますか?</p>
                    <v-layout row wrap>
                        <template v-for="serviceName in serviceProvided">
                            <v-flex
                                    :[servieButtonWidth]="true"
                                    text-xs-center
                                    pa-2
                                    :key="'service_'+serviceName"
                            >
                                <v-card block style="height:100px;"
                                        @click="setService(serviceName)"
                                        :color = "selectDisplay.service.color[serviceName]"
                                >
                                    <v-layout align-center justify-center row fill-height>
                                        <div class="font-weight-bold title">
                                            {{customMethodTitle[serviceName]}}
                                        </div>
                                    </v-layout>



                                </v-card>
                            </v-flex>
                        </template>




                    </v-layout>

                </v-expansion-panel-content>


                <v-expansion-panel-content

                >
                    <template v-slot:header>
                        <div>ご来店日: {{userSelect.day.dayTextLang}}</div>
                    </template>


                    <p class="pa-2 headline">お越しになる日は、いつですか?</p>

                    <v-layout row wrap>
                        <template v-for=" keyNum in pickupDays ">
                        <v-flex xs6 text-xs-center  pa-2 :key="keyNum">

                                <CheckoutHelper

                                        :keyNum = "keyNum"
                                        :serviceType="userSelect.service.name"
                                        :color = "selectDisplay.day[keyNum]"
                                />




                        </v-flex>
                        </template>

                    </v-layout>

                </v-expansion-panel-content>




                <v-expansion-panel-content

                >
                    <template v-slot:header>
                        <div>ご来店時間:{{userSelect.time}}</div>
                    </template>
                    <p class="pa-2 headline">何時にお越しになりますか?</p>
                    <h3 v-if="!userSelect.day.selectedNum">
                        お受取日を選択してください。
                    </h3>
                    <h3 v-if="!userSelect.service.name">
                        お受取方法を選択してください。
                    </h3>
                    <template v-for="hour in timesArray" >
                        <v-layout row wrap ma-2 :key="'hour_'+hour">
                        <template v-for="time in businessHours[userSelect.service.name].days[userSelect.day.selectedNum].times[hour]">
                            <v-flex xs3 text-xs-center pa-1 :key="'time_'+hour + '_' + time">
                                <v-btn
                                        block
                                        @click="timeSelected"
                                        :time="time"
                                        ref="timeButtons"
                                        :color="timeButtonColor[time]"
                                        :disabled="isPassed(userSelect.day,time)"
                                > {{time}} </v-btn>
                            </v-flex>
                        </template>
                        </v-layout>
                    </template>

                    <v-divider></v-divider>

                </v-expansion-panel-content>
                <v-expansion-panel-content

                >
                    <template v-slot:header>
                        <div>お客様について</div>
                    </template>
                    <v-flex xs12 class="pa-2">
                        <v-form v-model="validNameEmail" ref="formNameEmail">
                        <v-text-field
                            v-model = "userSelect.email"
                            label="Email"
                            placeholder="Email"
                            prepend-icon="email"
                            :rules="[rules.required, rules.email]"
                            inline
                            type="email"

                    >
                    </v-text-field>
                        <v-text-field
                                v-model = "userSelect.name"
                                label="お名前"
                                placeholder="お名前"
                                prepend-icon="person"
                                :rules="[rules.required]"
                                inline

                        >
                        </v-text-field>
                        </v-form>
                    </v-flex>
                    <v-form xs12 class="pa-2" v-if="userSelect.service.name == 'adt'">
                        <v-text-field
                                v-model="userSelect.carType"

                                label="車種"
                                placeholder="例: トヨタ プリウス"
                                hint="わかる範囲でお書きください"
                                required
                                prepend-icon="directions_car"
                                :rules="[rules.required]"
                        ></v-text-field>

                        <v-text-field
                                v-model="userSelect.carPlate"
                                :rules="[rules.required]"
                                label="ナンバープレート"
                                placeholder="例: 沖縄 111 れ 1234"
                                hint="数字のみでも構いません"
                                required
                                prepend-icon="crop_16_9"

                        ></v-text-field>

                        <strong>クルマの色:</strong>
                        <swatches
                                align = "center"
                                v-model="userSelect.carColor"
                                inline
                                show-border
                        ></swatches>

                    </v-form>

                    <v-flex xs12 class="pa-2" v-if="userSelect.service.name == 'dineIn'">
                        <v-text-field
                                v-model="userSelect.numOfGuest"

                                label="ご利用人数"
                                placeholder="例: 1"
                                hint="ご利用人数をお書きください"
                                required
                                prepend-icon="directions_car"

                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 class="pa-2" >
                        <v-checkbox
                                v-model="userSelect.optInThisShop"
                                label="このお店と系列店からのお得なお知らせなどを受け取る"
                                class="my-0"
                        ></v-checkbox>
                        <v-checkbox
                                v-model="userSelect.optInDikitoon"
                                label="Dikitoonや他のお店のお得なお知らせなどを受け取る"
                                class="my-0"
                        ></v-checkbox>
                        <p>ご注文に関連するメール(注文内容の確認など)は上記に関わらずEmailに送信いたします。</p>
                    </v-flex>

                    <v-flex xs12 class="pa-2">
                        <v-btn color="orange" block @click="goCheckout">決済画面へ</v-btn>
                    </v-flex>

                </v-expansion-panel-content>

            </v-expansion-panel>
        </v-flex>

    </v-layout>

</template>

<script>
    import  { Logger } from 'aws-amplify';
    const logger = new Logger('SetDate','INFO');
    import { AmplifyEventBus } from 'aws-amplify-vue'
    //import { uuid } from 'vue-uuid';
    import moment from 'moment-timezone'
    import {PriceMixIns} from '../mixins/price'
    import CheckoutHelper from '../components/CheckoutHelper'
    import Swatches from 'vue-swatches'
    import "vue-swatches/dist/vue-swatches.min.css"

    export default {
        mixins:[PriceMixIns],
        components:{'CheckoutHelper':CheckoutHelper,Swatches},

        data () {
            return {
                cart:{items:[]},
                totalPrice:0,
                feeTotal:0,
                lang:"",
                currency:"",
                panel:0,
                todayDate:"7月25日",
                userSelect:{
                    service:{
                        name:undefined,
                        langName:""
                    },
                    day:{
                        dayText:"",
                        dayTextLang:"",
                        selectedNum:undefined
                    },
                    time:"",
                    name:"",
                    email:"",
                    carType:"",
                    carPlate:"",
                    carColor:"",
                    numOfGuest:"",
                    optInThisShop:true,
                    optInDikitoon:true,
                },
                selectDisplay:{
                    service:{
                        color:{
                            adt:"default",
                            pickUp:"default",
                            dineIn:"default"
                        }
                    },
                    day:{
                        0:"default",
                        1:"default",
                        2:"default",
                        3:"default"
                    }
                },
                timesArray:[],
                timeButtonColor:{},
                timesNextDayArray:[],// to detect next day hours eg. 03:00
                //businessHours: undefined, // now computed
                validNameEmail:false,
                rules:{
                    required: value => !!value || '必ず入力してください。',
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'メールアドレスが正しくありません。'
                    }
                },
                availableMethods:[]
            }
        },
        created(){
            //console.log("created")
            AmplifyEventBus.$on('cartCurrent',this.cartCurrent)
            AmplifyEventBus.$on('daySelected',this.daySelected)
        },
        beforeDestroy () {
            logger.info("Checkout beforeDestroy")
            AmplifyEventBus.$off('cartCurrent',this.cartCurrent)
            AmplifyEventBus.$off('daySelected',this.daySelected)
        },
        async mounted() {
            AmplifyEventBus.$emit('getCart')
            //retrieve from localstorage
            const keys = ["name","email","carType","carPlate","carColor","optInThisShop","optInDikitoon"]

            for(let i in keys){
                if(localStorage.getItem(keys[i])){
                    //this.userSelect[keys[i]] = localStorage.getItem(keys[i])
                    this.$set(this.userSelect,keys[i],localStorage.getItem(keys[i]))
                    logger.info(keys[i],localStorage.getItem(keys[i]))
                }
            }
            logger.info("userSelect",this.userSelect)
            this.trackPage('/setDateTimeMethod/')
            AmplifyEventBus.$emit('setJourney', {key:"page",value:"受取日時の設定"} )
            // get businessHours

            //logger.info("businessHours by vuex",this.businessHours)
            //logger.info("currentTime",moment().format('llll'))
            // get availableMethods
            this.availableMethods = this.$store.state.menu.defalutSettings.serviceProvided
            if(this.availableMethods.length == 1){
                logger.info("only one single method available")
                this.setService(this.availableMethods[0])
            }
            logger.info("pickupDays",this.pickupDays)
        },
        computed:{
            serviceProvided:function(){
                const menu = this.$store.state.menu
                return menu.defalutSettings.serviceProvided
            },
            customMethodTitle:function(){
                const menu = this.$store.state.menu
                let methodNames = menu.defalutSettings.customMethodTitle
                if(!methodNames){
                    methodNames = {}
                }
                if(!methodNames["adt"]){
                    methodNames["adt"] = "お車にお届け"
                }
                if(!methodNames["pickUp"]){
                    methodNames["pickUp"] = "お持ち帰り"
                }
                if(!methodNames["dineIn"]){
                    methodNames["dineIn"] = "店内予約"
                }


                return methodNames
            },
            servieButtonWidth:function(){ //although gray, it is using at select service
                const numberOfAvailableService = this.$store.state.menu.defalutSettings.serviceProvided.length
                logger.info("numberOfAvailableService",numberOfAvailableService)
                const num = Math.floor( 12 / parseInt(numberOfAvailableService) )
                return "xs"+num
            },
            businessHours(){
                return this.$store.getters.businessHours(moment())
            },
            carColor(){
                return this.userSelect.carColor
            },
            pickupDays(){
                let res = []
                if(this.$store.state.menu.defalutSettings && this.$store.state.menu.defalutSettings.pickupDays){
                    for(let i in this.$store.state.menu.defalutSettings.pickupDays){
                        const day = this.$store.state.menu.defalutSettings.pickupDays[i]
                        switch(day){
                            case "today":
                                res.push(0)
                                break
                            case "tomorrow":
                                res.push(1)
                                break
                            case "dayAfterTomorrow":
                                res.push(2)
                                break
                            case "inThreeDays":
                                res.push(3)
                                break
                            default:
                                logger.info("pickupDays funny day",day)
                        }
                    }
                }else{
                    res = [0,1,2,3]
                }
                return res
            }

        },
        watch:{
            carColor(newVal){
                logger.info("selectedColor: " , newVal)
            },
            'userSelect.name': {
                handler:function(newVal){
                    localStorage.setItem('name',newVal)
                }
            },
            'userSelect.email': {
                handler:function(newVal){
                    localStorage.setItem('email',newVal)
                }
            },
            'userSelect.carType': {
                handler:function(newVal){
                    localStorage.setItem('carType',newVal)
                }
            },
            'userSelect.carPlate': {
                handler:function(newVal){
                    localStorage.setItem('carPlate',newVal)
                }
            },
            'userSelect.carColor': {
                handler:function(newVal){
                    localStorage.setItem('carColor',newVal)
                }
            },
            'userSelect.optInThisShop': {
                handler:function(newVal){
                    logger.info("optInThisShop",newVal)
                    localStorage.setItem('optInThisShop',newVal)
                }
            },
            'userSelect.optInDikitoon': {
                handler:function(newVal){
                    logger.info("optInDikitoon",newVal)
                    localStorage.setItem('optInDikitoon',newVal)
                }
            },
        },
        methods: {
            // Create an array the length of our items
            // with all values as true
            showMethod:function(method){
                let res = false
                if(this.availableMethods.indexOf(method) >= 0){
                    res = true
                }
                return res
            },
            cardClicked:function(){
                console.log("card clicked")
            },
            validation:function(){
                return true
            },
            cartCurrent:function(data){
                //console.log(cart)
                //console.log("cartCurrent")
                this.cart = data.cart
                this.lang = this.cart.lang
                this.currency = this.cart.currency
                this.totalPrice = this.cart.total
                this.feeTotal = this.cart.feeTotal
                //this.businessHours = data.businessHours
                if(this.currency == "JPY"){
                    this.totalPrice = Math.round(this.cart.total)
                }else{
                    this.totalPrice = Math.round(this.cart.total * 100) / 100
                }
                logger.info("totalPrice",this.totalPrice)

                this.totalPriceCurrency = this.getCurrencyFormatted(this.totalPrice);

                // business hours


            },

            setService:function(name){
                for(let i in this.selectDisplay.service.color){
                    if(i == name){
                        this.selectDisplay.service.color[i] = 'orange'
                    }else{
                        this.selectDisplay.service.color[i] = 'default'
                    }
                }
                logger.info(this.selectDisplay)
                this.userSelect.service.name = name

                if(this.customMethodTitle[name]){
                    this.userSelect.service.langName = this.customMethodTitle[name]
                }
                this.panel = 1
                this.setTimesArray()
                /*
                if(this.pickupDays.length == 1){
                    this.setDaySinglePickupDay(this.pickupDays[0])
                }
                */
            },
            setDaySinglePickupDay:function(keyNum){
                logger.info("serviceName",this.userSelect.service.name)
                if(!this.userSelect.service.name){
                    return false
                }
                logger.info("setDaySinglePickupDay keyNum",keyNum)
                const selected = {}
                selected.dayText = this.businessHours[this.userSelect.service.name].days[keyNum].dayText
                selected.dayTextLang = this.businessHours[this.userSelect.service.name].days[keyNum].dayTextLang
                selected.selectedNum = keyNum
                this.daySelected(selected)
            },
            daySelected:function(selected){
                this.userSelect.day.dayText = selected.dayText
                this.userSelect.day.dayTextLang = selected.dayTextLang
                this.userSelect.day.selectedNum = selected.keyNum
                for(let i in this.selectDisplay.day){
                    if(i == selected.keyNum){
                        this.selectDisplay.day[i] = "orange"
                    }else{
                        this.selectDisplay.day[i] = "default"
                    }
                }
                this.panel = 2
                this.setTimesArray()
            },
            setTimesArray:function(){
                this.timesArray = []
                this.timeButtonColor={}
                this.timesNextDayArray=[]

                logger.info("this.userSelect.day.selectedNum",this.userSelect.day.selectedNum)
                logger.info("this.userSelect.service.name",this.userSelect.service.name)
                if(this.userSelect.day.selectedNum >= 0 && this.userSelect.service.name){
                    const day = this.businessHours[this.userSelect.service.name].days[this.userSelect.day.selectedNum]
                    logger.info("day",day)
                    //logger.info("businessHours",this.businessHours[this.userSelect.service.name])
                    //logger.info("name",this.userSelect.service.name)
                    //logger.info("selectedNum",this.userSelect.day.selectedNum)
                    if(day.isBusinessDay){
                        logger.info("day.times",day.times)
                        const startHour = parseInt(day.times.startHour)
                        let endHour = parseInt(day.times.endHour)
                        if(startHour > endHour){
                            endHour = endHour + 24
                        }
                        for(let i = startHour;i<=endHour;i++){
                            //logger.info("pusshing",i)
                            let hourToPush = i
                            if(hourToPush > 24){
                                hourToPush = i - 24
                                this.timesNextDayArray.push(hourToPush)
                            }
                            this.timesArray.push(hourToPush)

                            for(let j in this.businessHours[this.userSelect.service.name].days[this.userSelect.day.selectedNum].times[hourToPush]){
                                const key = this.businessHours[this.userSelect.service.name].days[this.userSelect.day.selectedNum].times[hourToPush][j]
                                this.timeButtonColor[key]="default"
                            }
                        }
                    }
                }



                logger.info("timesArray",this.timesArray)
            },
            timeSelected:function(event){
                const time = event.currentTarget.getAttribute('time')
                //logger.info("timeSelected",event.currentTarget.getAttribute('time'))
                /*
                for(let item in this.$refs.timeButtons){
                    if(this.$refs.timeButtons[item].$attrs.time == time){
                        this.$refs.timeButtons[item].color = "orange"

                    }else{
                        this.$refs.timeButtons[item].color = "default"

                    }
                    //logger.info("loop:",this.$refs.timeButtons[item])
                }
                 */

                this.userSelect.time = time
                //logger.info("timeButtonColor",this.timeButtonColor)
                for(let i in this.timeButtonColor){
                    if(i==time){
                        this.timeButtonColor[i]="orange"
                    }else{
                        this.timeButtonColor[i]="default"
                    }
                }
                this.panel = 3

            },
            goCheckout:function(){
                const validationResult = this.$refs.formNameEmail.validate()
                if(!validationResult){
                    alert("お名前またはメールアドレスを再確認してください")
                    AmplifyEventBus.$emit('setJourney', {key:"error",value:"お名前またはメールアドレスを再確認してください"} )
                    return false
                }
                logger.info("userSelect",this.userSelect)
                let errorMsg = ""
                if(!this.userSelect.service.name){
                    errorMsg += "お受取方法が選択されていません。\n"
                }
                if(!this.userSelect.day.dayText){
                    errorMsg += "お受取日が選択されていません。\n"
                }
                if(!this.userSelect.time){
                    errorMsg += "お受取時刻が選択されていません。\n"
                }

                if(this.userSelect.service.name == "adt"){
                    if(!this.userSelect.carType){
                        errorMsg += "車種が入力されていません。\n"
                    }
                    if(!this.userSelect.carPlate){
                        errorMsg += "ナンバープレートが入力されていません。\n"
                    }
                    if(!this.userSelect.carColor){
                        errorMsg += "車両の色が選択されていません。\n"
                    }
                }


                if(errorMsg){
                    alert(errorMsg)
                    AmplifyEventBus.$emit('setJourney', {key:"error",value:errorMsg} )
                    return false
                }
                AmplifyEventBus.$emit('setUserSelect', this.userSelect)
                this.$router.push('/checkout')
            },
            disabledDurationFromNow:function(){
                let res = 10
                const service = this.userSelect.service.name
                if(service && this.$store.state.menu.defalutSettings
                    && this.$store.state.menu.defalutSettings.disabledDurationFromNow
                    && this.$store.state.menu.defalutSettings.disabledDurationFromNow[service]
                ){
                    res = this.$store.state.menu.defalutSettings.disabledDurationFromNow[service]
                }
                return res

            },
            isPassed:function(day,time){
                // day.dayText 2019-11-22
                const current = moment()
                const target = moment(day.dayText+"T"+time+"+09:00")
                const disabledDurationFromNow = this.disabledDurationFromNow()
                //logger.info("disabledDurationFromNow",disabledDurationFromNow)
                const added10min = target.subtract(disabledDurationFromNow,'minutes')
                if( this.isNextDay(time)){
                    target.add(1,'day')
                }
                const comparedResult = added10min.isBefore(current)
                //logger.info("time: "+time,comparedResult)
                //logger.info("current",current)
                //logger.info("isPassed time",time)
                //logger.info("timesNextDayArray",)
                return comparedResult
            },
            isNextDay:function(time){
                const first2char = time.substr(0,2)
                if( this.timesNextDayArray.indexOf( parseInt(first2char) ) < 0 ){
                    return false
                }else{
                    return true
                }
            }



        },

    }
</script>

<style>
    h1.smaller{
        font-size:1.8em;
    }
    .v-btn__content {
        flex-direction: column;
    }

</style>